import React from "react";
import "./Overlay.scss"; // Add styling for the overlay if needed

const Overlay = ({ onClick }) => {
  return <div className="overlay" onClick={onClick}></div>;
};

export default Overlay;
